<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div>
        </div>
        <a-button type="primary" @click="addMenu">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        style="width: 100%"
        :default-expand-all-rows="false"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :data-source="table.data">
        <a-table-column
          data-index="name"
          :title="$t('NAME') || '菜单名称'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="type"
          :title="$t('TYPE') || '分类'"
          width="180"
        >
          <template slot-scope="text, record">
            <a-tag v-if="record.type==='BUTTON'" type="success">按钮</a-tag>
            <a-tag v-if="record.type==='MENU'" type="info">菜单</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          :title="$t('ICON') || '图标'"
          width="100">
          <template slot-scope="text,record">
            <a-icon :type="record.icon"/>
          </template>
        </a-table-column>
        <a-table-column
          :title="$t('CODE') || '编码'"
          data-index="code"
        >
        </a-table-column>
        <a-table-column
          data-index="path"
          :title="$t('PATH') || '前端路径'">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <div class="table-operation-wrap">
              <a-button type="link" @click="editMenu(record.id)">  {{ $t('EDIT') || '编辑' }}
              </a-button>
              <a-button type="link" @click="deleteMenu(record.id)"> {{ $t('DELETE') || '删除' }}
              </a-button>
              <a-button type="link" @click="upMenu(record.id)">{{ $t('UP') || '上移' }}
              </a-button>
              <a-button type="link" @click="downMenu(record.id)">{{ $t('DOWN') || '下移' }}
              </a-button>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
             :footer="null"
             @close="closeForm"
             v-model="form.visible">
      <menu-edit
        v-if="form.visible"
        :menu-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </menu-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _deleteMenu,
  _downMenu,
  _queryMenus,
  _upMenu,
} from '@/api/sysMenuApi';
import MenuEdit from './MenuEdit.vue';
import { _deleteWindow } from '@/api/windowApi';

function treeGenerator(x, data) {
  const children = data
    .filter(child => child.parentId === x.id)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

async function getMenuList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const menus = await _queryMenus({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = menus
    .filter(x => !x.parentId)
    .map(x => treeGenerator(x, menus));
}

function addMenu() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editMenu(menuId) {
  this.form.data.id = menuId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getMenuList();
}

async function deleteMenu(menuId) {
  // const that = this;
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteMenu(menuId);
      if (result) {
        this.$message.success('删除成功');
        await this.getMenuList();
      }
    },
  });
}

async function upMenu(menuId) {
  this.$confirm({
    title: '是否上移菜单？',
    content: '',
    onOk: async () => {
      await _upMenu(menuId);
      this.$message.success('上移成功');
      await this.getMenuList();
    },
  });
}

async function downMenu(menuId) {
  this.$confirm({
    title: '是否下移菜单？',
    content: '',
    onOk: async () => {
      await _downMenu(menuId);
      this.$message.success('下移成功');
      await this.getMenuList();
    },
  });
}

export default {
  name: 'MenuList',
  components: { MenuEdit },
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getMenuList,
    deleteMenu,
    editMenu,
    addMenu,
    closeForm,
    upMenu,
    downMenu,
  },
  created() {
    this.getMenuList();
  },
};
</script>

<style scoped>

</style>
